/* eslint-disable import/no-anonymous-default-export */
import Login from "./auth/Login";
import ForgotPassword from "./auth/ForgotPassword";
import OtpVerification from "./auth/otp";
import ResetPassword from "./auth/ResetPassword";
import Dashboard from "./dashboard";
import ManageUser from "./manageUsers";
import ManageUserDetail from "./manageUsers/view";
import ManageSubadmin from "./manageSubadmin";

import ManageNotifications from "./manageNotifications";
import RecievedNotifications from "./recievedNotifications";
import ManageCms from "./manageCms";
import SubadminDetail from "./manageSubadmin/viewSubadmin";
import AddSubadmin from "./manageSubadmin/addSubadmin";
import ManageSubadminRoles from "./manageSubadmin/roles";
import AddRole from "./manageSubadmin/addRole";
import RoleDetail from "./manageSubadmin/viewRole";
import ManageProfile from "./manageProfile";
import EditProfile from "./manageProfile/edit";
import ChangePassword from "./manageProfile/changePassword";
import Edituser from "./manageUsers/edit";

import ManagePromotion from "./manage-promotion";
import AddPromotion from "./manage-promotion/addPromotion";
import AddNotification from "./manageNotifications/add";
import NotificationDetail from "./manageNotifications/view";
import ManageSystemSettings from "./manageSystemSettings";
import AddEmailTemplate from "./manageSystemSettings/addEmailTemplate";
import ManageStores from "./manageStores";
import AddStore from "./manageStores/add";
import StoreDetail from "./manageStores/view";
import ManageQrCode from "./manageQrCode";
import ManageRewards from "./manageRewards";
import AddRewards from "./manageRewards/add";
import RewardsDetail from "./manageRewards/view";
import ViewPromotion from "./manage-promotion/viewPromotion";
import ManageTransction from "./manage-transction";
import ViewTransction from "./manage-transction/viewTransction";
import ManageActivityLogs from "./manageActivityLogs";
import ManageFeedbackReports from "./manageFeedbackReports";
import ManageReadyMadeYoghurt from "./manage-readymade-yoghurt";
import AddReadyMadeYoghurt from "./manage-readymade-yoghurt/addReadyMadeYoghurt";
import OrderManagement from "./order-management/order-management";
import CustomerSupport from "./customer-support";
import Ratings from "./ratings";
import RevenueAnalytic from "./revenue-analytic";
import LoyaltyPoints from "./loyalty-points";
import AddLoyalty from "./loyalty-points/add";
import ManageFlavor from "./manage-flavour/page";
import ViewReadyMadeYoghurt from "./manage-readymade-yoghurt/view";
import ManageFlavorQuantity from "./manage-flavour/manage-quantity/page";
import ManageWorkout from "./manage-workout";
import AddDriver from "./manage-workout/add";
import ViewDriver from "./manage-workout/view";
import ManageDispatcher from "./manage-dispatchers";
import AddDispatcher from "./manage-dispatchers/add";
import ViewOrder from "./order-management/order-management/view";
import DiscountCoupon from "./DiscountAndCoupon/discountCoupon";
import AddDiscount from "./DiscountAndCoupon/add";
import ViewDiscount from "./DiscountAndCoupon/view";
import ManageYogurtType from "./manage-yogurt-type";
import YogurtTypeDetail from "./manage-yogurt-type/manage";
import ManageBoxArt from "./manage-box-art";
import ManageGreekBox from "./manage-greek-box";
import AddGreekBox from "./manage-greek-box/add";
import ManageToppings from "./manage-toppings";
import ManageProductCategories from "./manage-categories";
import ManageProducts from "./manage-products";
import ManageProductsDetail from "./manage-products/view";
import StoreInventory from "./manageStores/inventory";
import EditProgram from "./manage-dispatchers/edit";
import ViewProgram from "./manage-dispatchers/view";
import ManageBadges from "./achievements-badges-management/Badges";
import EditBadge from "./achievements-badges-management/add";
import ViewBadge from "./achievements-badges-management/view";
import ManageCommunityGroups from "./Community-Moderation";
import AddCommunityGroup from "./Community-Moderation/add";
import ViewCommunityGroup from "./Community-Moderation/view";
import Subscriptions from "./subscription";
import EditSubscription from "./subscription/edit";
import ViewSubscription from "./subscription/view";
import ManageCategories from "./manage-categories";
import ManageAttributes from "./manage-categories/manage-attributes";
import ManageSubCategories from "./manage-categories/manage-sub-category";
import Settings from "./settings";

export default {
  Login,
  ForgotPassword,
  OtpVerification,
  ResetPassword,
  Dashboard,
  ManageUser,
  Edituser,
  ManageUserDetail,
  ManageSubadmin,
  SubadminDetail,
  AddSubadmin,
  ManageSubadminRoles,
  AddRole,
  RoleDetail,

  ManageNotifications,
  AddNotification,
  NotificationDetail,
  RecievedNotifications,
  ManageCms,
  ManageProfile,
  EditProfile,
  ChangePassword,
  ManageSystemSettings,
  DiscountCoupon,
  AddDiscount,
  ViewDiscount,
  ManagePromotion,
  AddPromotion,
  AddEmailTemplate,
  ManageStores,
  AddStore,
  StoreDetail,
  ManageQrCode,
  ManageRewards,
  AddRewards,
  RewardsDetail,
  ViewPromotion,
  ManageTransction,
  ViewTransction,
  ManageActivityLogs,
  ManageFeedbackReports,
  ManageReadyMadeYoghurt,
  AddReadyMadeYoghurt,
  OrderManagement,
  ManageToppings,
  CustomerSupport,
  Ratings,
  RevenueAnalytic,
  LoyaltyPoints,
  AddLoyalty,
  ManageFlavor,
  ViewReadyMadeYoghurt,
  ManageFlavorQuantity,
  ManageWorkout,
  AddDriver,
  ViewDriver,
  ManageDispatcher,
  AddDispatcher,
  ViewOrder,

  ManageYogurtType,
  YogurtTypeDetail,
  ManageProducts,
  ManageBoxArt,
  ManageGreekBox,
  AddGreekBox,
  ManageProductCategories,
  ManageProductsDetail,
  StoreInventory,
  EditProgram,
  ViewProgram,
  ManageBadges,
  EditBadge,
  ViewBadge,
  ManageCommunityGroups,
  AddCommunityGroup,
  ViewCommunityGroup,
  Subscriptions,
  EditSubscription,
  ViewSubscription,
  ManageCategories,
  ManageAttributes,
  ManageSubCategories,
  Settings
  
};       